<script>
    import {t} from '$utils/lang.js';
    import {twMerge} from 'tailwind-merge';
    // Figma Review-Step headline (node 419:58). Rendered twice with responsive
    // visibility: on desktop at the top of the left column (Order.svelte,
    // "hidden lg:flex"), on mobile above the order summary (Checkout.svelte,
    // "lg:hidden") — because the summary is a separate flex child that sits
    // first in the mobile source order.
    const {class: cls = ''} = $props();
</script>

<div class={twMerge('flex flex-col gap-1', cls)} data-checkout-section="review-headline">
    <h1 class="font-black text-[28px] leading-tight text-cyprus">{t('Überprüfen & Kaufen')}</h1>
    <div class="flex items-center gap-2">
        <svg class="shrink-0 size-4 text-elm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
        <span class="font-bold text-sm text-elm">{t('Fast geschafft – bitte prüfe kurz Deine Bestellung.')}</span>
    </div>
</div>
